module.exports = __webpack_public_path__ + "img/transportMap.267f3e1d.png";